import { configureStore as createStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import assistants from '../assistants/slices/assistants';
import { auth } from '../auth/slices/auth';
import chat from '../chat/slices/chat';
import chatv2 from '../chat/slices/chatv2';
import parentApp from '../chat/slices/parentApp';
import promptUser from '../chat/slices/promptUser';
import chatspotAuth from '../chatspotAuth/slices/chatspotAuth';
import promptTemplates from '../promptTemplates/slices/promptTemplates';
import threads from '../threads/slices/threads';
import votes from '../votes/slices/votes';
import plugin from '../chat/slices/pluginSlice';
export const configureStore = (preloadedState = {}) => {
  return createStore({
    middleware: [thunk],
    devTools: {
      name: 'chatspot-widget-ui'
    },
    preloadedState,
    reducer: {
      assistants,
      auth,
      plugin,
      parentApp,
      chat,
      chatspotAuth,
      chatv2,
      promptUser,
      promptTemplates,
      threads,
      votes
    }
  });
};